//JWT decoder
interface AuthToken {
	aud: string;
	iss: string;
	iat: number;
	nbf: number;
	exp: number;
	acct: number;
	acr: string;
	aio: string;
	amr: string[];
	app_displayname: string;
	appid: string;
	appidacr: string;
	family_name: string;
	given_name: string;
	idtyp: string;
	ipaddr: string;
	name: string;
	oid: string;
	onprem_sid: string;
	platf: string;
	puid: string;
	rh: string;
	scp: string;
	sub: string;
	tenant_region_scope: string;
	tid: string;
	unique_name: string;
	upn: string;
	uti: string;
	ver: string;
	wids: string[];
	xms_idrel: string;
	xms_st: {
		sub: string;
	};
	xms_tcdt: number;
	alg: string;
}

export function decodeToken(token: string): any {
	try {
	if (!token) {
		return null;
	}

	const parts = token.split('.');

	if (parts.length !== 3) {
		throw new Error('Invalid token');
	}

	const decoded = atob(parts[1]);
	const data: AuthToken = JSON.parse(decoded);
	console.log('LoggedInUser:', data.unique_name ?? '');
	return data;
	} catch (error) {
    console.error('Invalid token:', error);
    return null; // Return null for invalid tokens
  }
}
